/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner } from './org-monthly-card-transaction-merged-transaction-detail-list-inner-merged-card-transaction-transaction-record-list-inner';

/**
 * 
 * @export
 * @interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransaction
 */
export interface OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransaction {
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransaction
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransaction
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransaction
     */
    'merchantName': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransaction
     */
    'merchantNameKana': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransaction
     */
    'merchantNameKanji': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransaction
     */
    'mergedMerchantName': string;
    /**
     * 
     * @type {number}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransaction
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransaction
     */
    'amountFx': number;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransaction
     */
    'currencyCode': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransaction
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransaction
     */
    'transactionType': OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransactionTransactionTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransaction
     */
    'creditSettlement': number;
    /**
     * 
     * @type {Array<OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner>}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransaction
     */
    'transactionRecordList': Array<OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransactionTransactionRecordListInner>;
    /**
     * 
     * @type {boolean}
     * @memberof OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransaction
     */
    'isCleared': boolean;
}

export const OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransactionTransactionTypeEnum = {
    confirm: 'CONFIRM',
    notConfirm: 'NOT_CONFIRM'
} as const;

export type OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransactionTransactionTypeEnum = typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransactionTransactionTypeEnum[keyof typeof OrgMonthlyCardTransactionMergedTransactionDetailListInnerMergedCardTransactionTransactionTypeEnum];


